import React from 'react';
import { Link } from 'react-router-dom';

import { address, companyEmail, companyPhone, footerText, socialLinks, routes } from '../../constants';

import logoSub from '../../images/logo-white-sub.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-5 col-md-6">
            <div className="box">
              <div className="logo">
                <Link to={routes.home}>
                  <img src={logoSub} width="200" alt="" />
                </Link>
              </div>
              <p>{footerText}</p>
              <div className="social_links">
                <ul>
                  <li>
                    <a href={socialLinks.facebook}>
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={socialLinks.instagram}>
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href="contact.html#">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="contact.html#">
                      <i className="fab fa-google-plus-g"></i>
                    </a>
                  </li>
                  <li>
                    <a href="contact.html#">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-6">
            <div className="box box2">
              <h2>Links</h2>
              <ul>
                <li>
                  <a href="contact.html#">Home</a>
                </li>
                <li>
                  <a href="contact.html#">About</a>
                </li>
                <li>
                  <a href="contact.html#">Services</a>
                </li>
                <li>
                  <a href="contact.html#">FAQ</a>
                </li>
                <li>
                  <a href="contact.html#">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-6">
            <div className="box box3">
              <h2>About Us</h2>
              <ul>
                <li>
                  <a href="contact.html#">About Us</a>
                </li>
                <li>
                  <a href="contact.html#">Blog</a>
                </li>
                <li>
                  <a href="contact.html#">Contact Us</a>
                </li>
                <li>
                  <a href="contact.html#">Sign in</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6">
            <div className="box box4">
              <h2>Contact Us</h2>
              <p>{address}</p>
              <a href="contact.html#">{companyEmail}</a>
              <a href="contact.html#">{companyPhone}</a>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <p className="text-center">
          © 2020 <b>Browncon Investment</b>. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
